const a = (e = {}) => ({
  dsn: e.dsn,
  environment: e.environment ?? "local",
  sendDefaultPii: e.sendDefaultPii ?? !0,
  enableLogs: e.enableLogs ?? !0,
  tracesSampleRate: e.tracesSampleRate ?? 1,
  replaysSessionSampleRate: e.replaysSessionSampleRate ?? 0.1,
  replaysOnErrorSampleRate: e.replaysOnErrorSampleRate ?? 1
});
export {
  a as createSentryInitOptions
};
